<template>
  <div class='body'>
    <div class='sidebar'>
      <h4>Invite Codes:</h4>
      <ul>
        <li v-for='code in codes' :key='code.id'>
          <span>{{code.value}}</span>
          <span><i class='fas fa-times'/></span>
        </li>
      </ul>
    </div>
    <div class='detail'>
      <div><span @click='showCreate=true'>Create</span></div>
      <aGrid
        style='width: 100%'
        :rows='attendees'
        @rowselected='setSelected'
      />
    </div>
    <attendeeDetail
      v-if='showDetail'
      :attendee='selected'
      @close='showDetail=false'
    />
    <attendeeCreate
      v-if='showCreate'
      :eventid='id'
      @close='showCreate=false'
    />
  </div>
</template>

<script>
import { DateTime } from "luxon";
import aGrid from "../aGrid";
import attendeeDetail from "./attendeeDetail";
import attendeeCreate from "./attendeeCreate";
function objToArray(obj) {
  var result = [];
  for (var key in obj) {
    result.push(obj[key]);
  }
  return result;
}
export default {
  props: ["id"],
  data() {
    return {
      attendees: [],
      selected: null,
      showDetail: false,
      showCreate: false,
      codes: {
        1: { id: 1, value: "ABCDEFG" }
      }
    };
  },
  methods: {
    setSelected(row) {
      this.selected = row;
      this.showDetail = true;
    },
    get: function() {
      return this.$store
        .dispatch("attendees/getForEvent", { eventId: this.id })
        .then(() => this.$store.getters["attendees/attendees"]);
    }
  },
  beforeMount: function() {
    this.get().then(results => {
      this.attendees = results;
    });
  },
  components: {
    aGrid,
    attendeeDetail,
    attendeeCreate
  },
  mounted: function() {}
};
</script>

<style scoped lang='scss'>
.body {
  color: $primary;
  padding: 0px;
  background: white;
  border-radius: 4px;
  border: 1px solid $gray-4;
}
.sidebar {
  width: 250px;
  border-right: 1px solid $gray-4;
  flex-shrink: 0;
}
.detail {
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/event/attendees.vue